import { Link } from "react-router-dom";

import { getLink, trans } from "~/providers/lang";
import { ROUTES } from '~/const';
import { mainStore } from "~/stores/main";
import ArrowRight from "../ArrowRight";

import "./style.less";

export default function Categories() {
	const isSmallDevice = mainStore(state => state.data.isSmallDevice);

	return <div className="body-background">
		<div className="video-preview-top"></div>
		<div className="video-preview">
			<div className="next-video-items">
				{ !isSmallDevice && <div className="next-video-item">
					<h2 className="main-clothes" dangerouslySetInnerHTML={{ __html: trans('home.news.item33') }} />
					<p className="main-clothes-desc desc-34" dangerouslySetInnerHTML={{ __html: trans('home.news.item34') }} />
				</div> }
				<div className="next-video-item">
					<h2 className="main-clothes">
						{trans('home.wedding.title')}
					</h2>
					<p className="main-clothes-desc" dangerouslySetInnerHTML={{ __html: trans('home.wedding.desc') }} />
					<div className="main-clothes-link">
						<Link to={getLink(ROUTES.wedding)} className="clothes-icon">
							<ArrowRight />
						</Link>
					</div>
				</div>
				<div className="next-video-item">
					<h2 className="main-clothes">
						{trans('home.formal.title')}
					</h2>
					<p className="main-clothes-desc">
						{trans('home.formal.desc')}
					</p>
					<div className="main-clothes-link">
						<Link to={getLink(ROUTES.formal)} className="clothes-icon">
							<ArrowRight />
						</Link>
					</div>
				</div>
				<div className="next-video-item">
					<h2 className="main-clothes">
						{trans('home.services.title')}
					</h2>
					<p className="main-clothes-desc">
						{trans('home.services.desc')}
					</p>
					<div className="main-clothes-link">
						<Link to={getLink(ROUTES.ourCommodity)} className="clothes-icon">
							<ArrowRight />
						</Link>
					</div>
				</div>
			</div>
		</div>
	</div>;
}
